<script>
import baseMixin from '@mixins/baseMixin'
import TheDebugBar from '@components/dev/the-debug-bar.vue'

export default {
  components: {
    TheDebugBar,
  },
  mixins: [baseMixin],
  computed: {
    compBg() {
      return {
        backgroundImage: `url(${require('../../assets/images/backgrounds/bg_login.jpg')})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        opacity: '1',
      }
    },
  },
}
</script>

<template>
  <v-app id="rr-vue">
    <TheDebugBar />
    <v-main :style="compBg" :dark="setTheme()">
      <v-container class="fill-height" fluid>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
            <slot />
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
